// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.knowledge-info-box {
    display: flex;
    align-items: center;
    flex-direction: row;
    gap: 20px;
    background-color: #5616ea25;
    border-radius: 10px;
    padding: 15px;
    padding-top: 12px;
    padding-bottom: 12px;
    line-height: 1.45;
    border-left: 5px solid #5616ea;
}

.knowledge-info-text {
    display: flex;
    align-items: left;
    flex-direction: column;
}

.knowledge-info-text p {
    margin: 0;
    padding: 0;
}

.knowledge-info-text ul {
    margin: 0.5rem 0;
    padding-left: 1.2rem;
    list-style-type: disc;
    margin-bottom: 0;
    margin-top: 5px;
}

.knowledge-info-text li {
    margin-top: 7px;
}

.knowledge-info-icon {
    font-size: 24px;
    color: #5616ea;
  flex-shrink: 0;
}

.knowledge-tab-info-box {
  margin-top: 0px;
}

.file-tag-parent {
    display: flex;
    flex-direction: row;
    text-align: center;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
}

.file-tag {
    display: inline-block;
    padding: 5px;
    padding-right: 7px;
    padding-top: 1px;
    padding-bottom: 1px;
    border-radius: 10px;
    background-color: #5616ea;
    color: white;
}

.expand-toggle {
    background-color: transparent;
    border: none;
    outline: none;
    font-size: 24px;
    padding-bottom: 10px;
    cursor: pointer;
    transition: 0.3s ease, color 0.3s ease;
    color: #5616ea;
}

.expand-toggle:hover {
    scale: 1.15;
}

.rescraping-activate-settings-container {
    display: flex;
    align-items: center;
    gap: 8px;
}

.rescraping-toggle {
  margin: 0 !important;
}

.rescraping-settings-button {
    background-color: transparent;
    border: none;
    outline: none;
    font-size: 20px;
    color: rgb(79, 79, 79);
    transition: 0.4s ease, color 0.3s ease;
    cursor: pointer;
    margin-top: 2px;
}

.rescraping-settings-button:hover {
    scale: 1.15;
}

.rescraping-settings-button:disabled {
    cursor: not-allowed;
    scale: 1.0;
}

.rescraping-toggle-loading {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #333;
    padding: 9px 0;
    margin-left: 11px;
}

/* --- Usage bar styles (used in selection-container via botSettings) --- */

.knowledge-tabs {
  display: flex;
  padding: 6px;
  padding-top: 12px;
  padding-bottom: 6px;
  padding-left: 8px;
  border-radius: 8px;
  gap: 20px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  -ms-overflow-style: none;
  margin-top: -6px;
  margin-bottom: -6px;
}

.knowledge-tabs::-webkit-scrollbar {
  display: none;
}

.knowledge-tab {
  all: unset;
  position: relative;
  cursor: pointer;
  font-size: 17px;
  padding: 8px 10px;
  border: 2px solid transparent;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #353b43;
  transition: background 0.2s, color 0.2s, font-weight 0.2s;
  box-shadow: 0 0 0 1px #e3e4e7;
  flex-shrink: 0;
  white-space: nowrap;
  box-sizing: border-box;
}

.knowledge-tab:last-child {
  margin-right: 0;
}

.knowledge-tab:hover {
  background: #e5e7eb;
  transition: background 0.2s, color 0.2s, box-shadow 0.2s;
}

.knowledge-tab.active {
  background: #ffffff;
  border-color: transparent;
  color: #111827;
  box-shadow: none;
  transition: background 0.2s, color 0.2s, box-shadow 0.2s;
}

.knowledge-tab.active:hover {
  background: #ffffff;
}

.knowledge-tab-border-svg {
  position: absolute;
  inset: -2px;
  width: calc(100% + 4px);
  height: calc(100% + 4px);
  overflow: visible;
  pointer-events: none;
  z-index: 1;
}

.knowledge-tab-border-rect {
  x: 0.5px;
  y: 0.5px;
  width: calc(100% - 1px);
  height: calc(100% - 1px);
  rx: 8px;
  ry: 8px;
  fill: none;
  stroke: #5616ea;
  stroke-width: 1px;
  stroke-dasharray: 100;
  stroke-dashoffset: 100;
  /* No vector-effect: see ChatHistories.css .platform-filter-border-rect. */
  shape-rendering: geometricPrecision;
}

.knowledge-tab.active .knowledge-tab-border-rect {
  animation: knowledgeTabBorderDraw 0.7s ease-out forwards;
}

@keyframes knowledgeTabBorderDraw {
  to {
    stroke-dashoffset: 0;
  }
}

.knowledge-tab-badge {
  position: absolute;
  top: -13px;
  right: -7px;
  background-color: #5616ea;
  color: #fff;
  border-radius: 8px;
  padding: 5px;
  padding-bottom: 4px;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  box-shadow: 0 2px 6px rgba(94, 27, 255, 0.4);
  white-space: nowrap;
}

.rescraping-new-badge {
  background-color: #5616ea;
  color: #fff;
  border-radius: 8px;
  padding: 5px;
  padding-bottom: 4px;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  box-shadow: 0 2px 6px rgba(94, 27, 255, 0.4);
  white-space: nowrap;
}

.coming-soon-badge {
  background-color: #e5e7eb;
  color: #6b7280;
  border-radius: 6px;
  padding: 4px 6px;
  font-size: 10px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  white-space: nowrap;
}

/* --- FAQ form should look like a knowledge-container box --- */
.faq-form {
  display: flex;
  flex-direction: column;
  border: none;
  background-color: transparent;
  padding: 20px;
  padding-right: 45px;
  padding-top: 15px;
  gap: 10px;

}

.faq-label {
  font-size: 14px;
  color: #353535;
  font-weight: 600;
  margin-top: 8px;
  margin-bottom: 4px;
}

.faq-input,
.faq-textarea {
  width: 100%;
  font-size: 14px;
  padding: 8px 10px;
  border-radius: 8px;
  border: 1px solid #d1d5db;
  background-color: #fff;
  font-family: "DM Sans", sans-serif;
}

.faq-input:focus,
.faq-textarea:focus {
  outline: none;
  border-color: #5616ea;
  box-shadow: 0 0 0 3px rgba(94, 27, 255, 0.18);
}

.faq-add-btn {
  background-color: #5616ea;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: 0.3s ease;
}

.faq-add-btn:hover {
  background-color: #4915cc;
}

.faq-add-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.faq-row {
  display: flex;
  align-items: center;
  border: 1px solid #e5e7eb;
  background-color: #ffffff;
  padding: 12px;
  border-radius: 10px;
}

.faq-row + .faq-row {
  margin-top: 10px;
}

.faq-row-question {
  font-size: 14px;
  color: #111827;
  font-weight: 500;
}

.knowledge-tab-count {
  position: absolute;
  top: -10px;
  left: -7px;
  z-index: 2;
  background-color: #ffffff;
  color: #000000;
  border-radius: 8px;
  font-size: 12px;
  padding: 1px 4px;
  font-weight: 500;
  white-space: nowrap;
  border: 0.5px solid rgb(171, 171, 171);
}

/* --- Search input next to header title --- */
.header-title-with-search {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}

.knowledge-search-container {
  position: relative;
  display: flex;
  align-items: center;
}

.knowledge-search-icon {
  position: absolute;
  left: 10px;
  color: #9ca3af;
  font-size: 14px;
  pointer-events: none;
}

.knowledge-search-input {
  padding: 6px 28px 6px 32px;
  font-size: 14px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  outline: none;
  width: 180px;
  transition: border-color 0.2s, box-shadow 0.2s;
  font-family: "DM Sans", sans-serif;
}

.knowledge-search-input:focus {
  border-color: #5616ea;
  box-shadow: 0 0 0 3px rgba(86, 22, 234, 0.15);
}

.knowledge-search-input::placeholder {
  color: #9ca3af;
}

.knowledge-search-clear {
  position: absolute;
  right: 8px;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: #9ca3af;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s;
}

.knowledge-search-clear:hover {
  color: #6b7280;
}

/* --- Tree View Styles --- */
.knowledge-tree-content {
  padding-bottom: 10px;
}

/* Disable ALL visual feedback in tree view on row interaction */
.knowledge-tree-content .MuiTreeItem-content,
.knowledge-tree-content .MuiTreeItem-content:hover,
.knowledge-tree-content .MuiTreeItem-content:focus,
.knowledge-tree-content .MuiTreeItem-content:active,
.knowledge-tree-content .MuiTreeItem-content.Mui-focused,
.knowledge-tree-content .MuiTreeItem-content.Mui-selected {
  background-color: transparent !important;
}

/* Disable all transitions on tree content */
.knowledge-tree-content .MuiTreeItem-content * {
  transition: none !important;
}

/* Checkbox specific overrides */
.knowledge-tree-content .MuiCheckbox-root:hover,
.knowledge-tree-content .MuiCheckbox-root:focus,
.knowledge-tree-content .MuiCheckbox-root:active,
.knowledge-tree-content .MuiCheckbox-root.Mui-focusVisible {
  background-color: transparent !important;
}

.knowledge-tree-content .MuiCheckbox-root .MuiTouchRipple-root {
  display: none;
}

/* Lock checkbox icon color - purple border when unchecked */
.knowledge-tree-content .MuiCheckbox-root svg,
.knowledge-tree-select-all-row .MuiCheckbox-root svg {
  color: #5616ea !important;
}

.knowledge-tree-content .MuiCheckbox-root.Mui-checked svg,
.knowledge-tree-select-all-row .MuiCheckbox-root.Mui-checked svg {
  color: #5616ea !important;
}

/* Lock date/calendar icon color */
.knowledge-tree-content .knowledge-tree-item-date,
.knowledge-tree-content .knowledge-tree-item-date svg,
.knowledge-tree-content .MuiTreeItem-content:focus .knowledge-tree-item-date,
.knowledge-tree-content .MuiTreeItem-content:active .knowledge-tree-item-date,
.knowledge-tree-content .MuiTreeItem-content.Mui-focused .knowledge-tree-item-date,
.knowledge-tree-content .MuiTreeItem-content.Mui-selected .knowledge-tree-item-date,
.knowledge-tree-content .MuiTreeItem-content:focus .knowledge-tree-item-date svg,
.knowledge-tree-content .MuiTreeItem-content:active .knowledge-tree-item-date svg,
.knowledge-tree-content .MuiTreeItem-content.Mui-focused .knowledge-tree-item-date svg,
.knowledge-tree-content .MuiTreeItem-content.Mui-selected .knowledge-tree-item-date svg {
  color: #9ca3af !important;
}

/* Lock action button colors */
.knowledge-tree-content .knowledge-action-button,
.knowledge-tree-content .knowledge-action-button svg,
.knowledge-tree-content .MuiTreeItem-content:focus .knowledge-action-button,
.knowledge-tree-content .MuiTreeItem-content:active .knowledge-action-button,
.knowledge-tree-content .MuiTreeItem-content.Mui-focused .knowledge-action-button,
.knowledge-tree-content .MuiTreeItem-content.Mui-selected .knowledge-action-button,
.knowledge-tree-content .MuiTreeItem-content:focus .knowledge-action-button svg,
.knowledge-tree-content .MuiTreeItem-content:active .knowledge-action-button svg,
.knowledge-tree-content .MuiTreeItem-content.Mui-focused .knowledge-action-button svg,
.knowledge-tree-content .MuiTreeItem-content.Mui-selected .knowledge-action-button svg {
  color: #464646 !important;
}

/* Lock text colors */
.knowledge-tree-content .knowledge-tree-item-path,
.knowledge-tree-content .MuiTreeItem-content:focus .knowledge-tree-item-path,
.knowledge-tree-content .MuiTreeItem-content:active .knowledge-tree-item-path,
.knowledge-tree-content .MuiTreeItem-content.Mui-focused .knowledge-tree-item-path,
.knowledge-tree-content .MuiTreeItem-content.Mui-selected .knowledge-tree-item-path {
  color: #4b5563 !important;
}

.knowledge-tree-content .knowledge-tree-domain-name,
.knowledge-tree-content .MuiTreeItem-content:focus .knowledge-tree-domain-name,
.knowledge-tree-content .MuiTreeItem-content:active .knowledge-tree-domain-name,
.knowledge-tree-content .MuiTreeItem-content.Mui-focused .knowledge-tree-domain-name,
.knowledge-tree-content .MuiTreeItem-content.Mui-selected .knowledge-tree-domain-name {
  color: #111827 !important;
}

.knowledge-tree-content .knowledge-tree-path-name,
.knowledge-tree-content .MuiTreeItem-content:focus .knowledge-tree-path-name,
.knowledge-tree-content .MuiTreeItem-content:active .knowledge-tree-path-name,
.knowledge-tree-content .MuiTreeItem-content.Mui-focused .knowledge-tree-path-name,
.knowledge-tree-content .MuiTreeItem-content.Mui-selected .knowledge-tree-path-name {
  color: #374151 !important;
}

/* Lock count badge colors */
.knowledge-tree-content .knowledge-tree-count,
.knowledge-tree-content .MuiTreeItem-content:focus .knowledge-tree-count,
.knowledge-tree-content .MuiTreeItem-content:active .knowledge-tree-count,
.knowledge-tree-content .MuiTreeItem-content.Mui-focused .knowledge-tree-count,
.knowledge-tree-content .MuiTreeItem-content.Mui-selected .knowledge-tree-count {
  color: #464646 !important;
  background-color: #f3f4f6 !important;
}

/* Lock folder icon colors */
.knowledge-tree-content .knowledge-tree-domain-label svg,
.knowledge-tree-content .knowledge-tree-path-label svg,
.knowledge-tree-content .MuiTreeItem-content:focus .knowledge-tree-domain-label svg,
.knowledge-tree-content .MuiTreeItem-content:active .knowledge-tree-domain-label svg,
.knowledge-tree-content .MuiTreeItem-content.Mui-focused .knowledge-tree-domain-label svg,
.knowledge-tree-content .MuiTreeItem-content.Mui-selected .knowledge-tree-domain-label svg,
.knowledge-tree-content .MuiTreeItem-content:focus .knowledge-tree-path-label svg,
.knowledge-tree-content .MuiTreeItem-content:active .knowledge-tree-path-label svg,
.knowledge-tree-content .MuiTreeItem-content.Mui-focused .knowledge-tree-path-label svg,
.knowledge-tree-content .MuiTreeItem-content.Mui-selected .knowledge-tree-path-label svg {
  color: #5616ea !important;
}

/* Loading spinner icon color */
.knowledge-loading-spinner-icon {
  color: #5616ea !important;
}

.knowledge-tree-select-all-row {
  display: flex;
  align-items: center;
  padding: 4px 0;
  margin-bottom: 0;
  flex-wrap: wrap;
  gap: 12px;
}

/* Scraping links indicator */
.scraping-links-indicator {
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: #fef3c7;
  border: 1px solid #fbbf24;
  border-radius: 8px;
  padding: 6px 12px;
  font-size: 13px;
}

.scraping-indicator-icon {
  color: #f59e0b;
  font-size: 14px;
}

.scraping-indicator-text {
  color: #92400e;
  font-weight: 500;
}

.knowledge-tree-select-all-label {
  flex: 1 1;
  font-size: 14px;
  font-weight: 500;
  color: #111827;
  margin-left: 8px;
}

.knowledge-tree-domain-label {
  display: flex;
  align-items: center;
  padding: 6px 0;
  font-weight: 500;
}

.knowledge-tree-domain-name {
  flex: 1 1;
  font-size: 14px;
  color: #111827;
}

.knowledge-tree-domain-count {
  background-color: #e5e7eb;
  color: #374151;
  border-radius: 10px;
  padding: 2px 8px;
  font-size: 12px;
  font-weight: 500;
  margin-left: 8px;
}

/* Unified icon box sizing for tree items */
.knowledge-icon-box {
  min-width: 36px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  border-radius: 6px;
  font-size: 11px;
  padding: 0 6px;
}

/* Count badge for tree items */
.knowledge-tree-count {
  background-color: #f3f4f6;
  color: #464646;
  font-weight: 500;
}

/* Path segment level (folder) */
.knowledge-tree-path-label {
  display: flex;
  align-items: center;
  padding: 5px 0;
  font-weight: 500;
}

.knowledge-tree-path-name {
  flex: 1 1;
  font-size: 13px;
  color: #374151;
}

.knowledge-tree-path-count {
  background-color: #fef3c7;
  color: #92400e;
  border-radius: 10px;
  padding: 2px 8px;
  font-size: 11px;
  font-weight: 500;
  margin-left: 8px;
}

.knowledge-tree-item-label {
  display: flex;
  align-items: center;
  padding: 4px 0;
  width: 100%;
}

.knowledge-tree-item-path {
  flex: 1 1;
  font-size: 13px;
  color: #4b5563;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 300px;
}

.knowledge-tree-item-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-left: auto;
  padding-left: 16px;
}

.knowledge-tree-item-date {
  font-size: 12px;
  color: #9ca3af;
  display: flex;
  align-items: center;
}

.knowledge-bulk-actions {
  font-size: 15px;
}

@media (max-width: 768px) {
    .file-tag-parent {
        gap: 5px;
    }

    .knowledge-header {
        flex-wrap: wrap;
        gap: 10px;
    }

    .knowledge-header .header-title-with-search {
        flex-basis: 100%;
        order: 2;
        flex-direction: column;
        align-items: flex-start;
        gap: 0;
    }

    .knowledge-header .header-title-with-search .header-title {
        width: auto;
        margin-bottom: 10px;
    }

    .knowledge-header .knowledge-bulk-actions {
        order: 1;
        flex-basis: 100%;
        justify-content: flex-start !important;
    }

    .knowledge-header .knowledge-search-container {
        width: 100%;
    }

    .knowledge-search-input {
        width: 100%;
        max-width: none;
    }
}

/* --- Virtualized Tree Styles --- */
.virtual-tree-row {
  display: flex;
  align-items: center;
  overflow: hidden;
}

.virtual-tree-expand-btn {
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  margin-right: 4px;
  color: #6b7280;
  flex-shrink: 0;
}

.virtual-tree-expand-btn:hover {
  color: #374151;
}

.virtual-tree-expand-btn svg {
  font-size: 12px;
}

.virtual-tree-expand-placeholder {
  width: 20px;
  margin-right: 4px;
  flex-shrink: 0;
}

/* Tree line indicator for leaf nodes (links without children) */
.virtual-tree-line-indicator {
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 4px;
  margin-top: 2px;
  flex-shrink: 0;
  position: relative;
}

/* Vertical line (going up) */
.virtual-tree-line-indicator::before {
  content: '';
  position: absolute;
  left: 10%;
  top: 30%;
  width: 2px;
  height: 20%;
  background-color: #5616ea;
}

/* Horizontal line (going right) */
.virtual-tree-line-indicator::after {
  content: '';
  position: absolute;
  left: 10%;
  top: 50%;
  width: 70%;
  height: 1.5px;
  background-color: #5616ea;
}

/* Clickable row area for expand/collapse */
.virtual-tree-row-clickable {
  display: flex;
  align-items: center;
  flex: 1 1;
  cursor: pointer;
  border-radius: 4px;
  padding: 2px 4px;
  margin: -2px -4px;
  transition: background-color 0.15s ease;
}

.virtual-tree-row-clickable:hover {
  background-color: rgba(86, 22, 234, 0.06);
}

/* Virtualized tree labels */
.virtual-tree-row .knowledge-tree-domain-label,
.virtual-tree-row .knowledge-tree-path-label,
.virtual-tree-row .knowledge-tree-item-label {
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}

/* Checkbox styling for virtualized tree */
.virtual-tree-row .MuiCheckbox-root svg {
  color: #5616ea !important;
}

.virtual-tree-row .MuiCheckbox-root.Mui-checked svg {
  color: #5616ea !important;
}

/* Show more button styles */
.knowledge-tree-show-more {
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}

.knowledge-tree-show-more-btn {
  background: none;
  border: none;
  color: #5616ea;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 6px;
  transition: background-color 0.2s;
  font-family: inherit;
}

.knowledge-tree-show-more-btn:hover {
  background-color: rgba(86, 22, 234, 0.1);
}

/* Why a row failed (knowledgeStatus.js): short inline note next to the red X,
   full text on hover. */
/* Failed-row reason (knowledgeStatus.js). On the card lists it is its own flex
   cell between the name and the date: the name column gives up its fixed 60%
   width on such rows so the reason gets the whole middle and rarely truncates. */
.knowledge-item:has(> .knowledge-failure-slot) > .knowledge-link {
    width: auto;
    flex: 0 0 auto;
    max-width: 45%;
    min-width: 0;
    white-space: nowrap;
}

.knowledge-item:has(> .knowledge-failure-slot) > .knowledge-link .knowledge-status-link {
    overflow: hidden;
    text-overflow: ellipsis;
}

.knowledge-failure-slot {
    flex: 1 1 auto;
    min-width: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 16px;
}

.knowledge-failure-slot .info-tooltip-wrapper {
    min-width: 0;
    max-width: 100%;
}

.knowledge-failure-reason {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    max-width: 100%;
    min-width: 0;
    font-size: 0.8rem;
    font-weight: 400;
    color: #b42318;
    vertical-align: middle;
    cursor: default;
}

.knowledge-failure-text {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.knowledge-failure-icon {
    color: #f79009;         /* warning orange */
    font-size: 0.9rem;
    flex-shrink: 0;
}

/* Inline variant (website-links tree rows). */
.virtual-tree-row .knowledge-failure-reason,
.knowledge-tree-item .knowledge-failure-reason {
    margin-left: 10px;
    max-width: 380px;
}
`, "",{"version":3,"sources":["webpack://./src/components/knowledgeOverview.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;IACT,2BAA2B;IAC3B,mBAAmB;IACnB,aAAa;IACb,iBAAiB;IACjB,oBAAoB;IACpB,iBAAiB;IACjB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,SAAS;IACT,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,cAAc;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,QAAQ;AACZ;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,6BAA6B;IAC7B,YAAY;IACZ,aAAa;IACb,eAAe;IACf,oBAAoB;IACpB,eAAe;IACf,sCAAsC;IACtC,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;EACE,oBAAoB;AACtB;;AAEA;IACI,6BAA6B;IAC7B,YAAY;IACZ,aAAa;IACb,eAAe;IACf,sBAAsB;IACtB,sCAAsC;IACtC,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,WAAW;IACX,cAAc;IACd,iBAAiB;AACrB;;AAEA,2EAA2E;;AAE3E;EACE,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,iCAAiC;EACjC,qBAAqB;EACrB,wBAAwB;EACxB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,yDAAyD;EACzD,6BAA6B;EAC7B,cAAc;EACd,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,wDAAwD;AAC1D;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,wDAAwD;AAC1D;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;EACjB,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,QAAQ;EACR,QAAQ;EACR,uBAAuB;EACvB,wBAAwB;EACxB,OAAO;EACP,OAAO;EACP,UAAU;EACV,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;EACtB,0EAA0E;EAC1E,mCAAmC;AACrC;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,gEAAgE;AAChE;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,SAAS;;AAEX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,UAAU;EACV,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA,8CAA8C;AAC9C;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,8CAA8C;EAC9C,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;EACE,oBAAoB;AACtB;;AAEA,gEAAgE;AAChE;;;;;;EAME,wCAAwC;AAC1C;;AAEA,4CAA4C;AAC5C;EACE,2BAA2B;AAC7B;;AAEA,gCAAgC;AAChC;;;;EAIE,wCAAwC;AAC1C;;AAEA;EACE,aAAa;AACf;;AAEA,4DAA4D;AAC5D;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA,kCAAkC;AAClC;;;;;;;;;;EAUE,yBAAyB;AAC3B;;AAEA,8BAA8B;AAC9B;;;;;;;;;;EAUE,yBAAyB;AAC3B;;AAEA,qBAAqB;AACrB;;;;;EAKE,yBAAyB;AAC3B;;AAEA;;;;;EAKE,yBAAyB;AAC3B;;AAEA;;;;;EAKE,yBAAyB;AAC3B;;AAEA,4BAA4B;AAC5B;;;;;EAKE,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA,4BAA4B;AAC5B;;;;;;;;;;EAUE,yBAAyB;AAC3B;;AAEA,+BAA+B;AAC/B;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,SAAS;AACX;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,2CAA2C;AAC3C;EACE,eAAe;EACf,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA,+BAA+B;AAC/B;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,SAAO;EACP,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;IACI;QACI,QAAQ;IACZ;;IAEA;QACI,eAAe;QACf,SAAS;IACb;;IAEA;QACI,gBAAgB;QAChB,QAAQ;QACR,sBAAsB;QACtB,uBAAuB;QACvB,MAAM;IACV;;IAEA;QACI,WAAW;QACX,mBAAmB;IACvB;;IAEA;QACI,QAAQ;QACR,gBAAgB;QAChB,sCAAsC;IAC1C;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;QACX,eAAe;IACnB;AACJ;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,iBAAiB;EACjB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;AAChB;;AAEA,gEAAgE;AAChE;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA,6BAA6B;AAC7B;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,UAAU;EACV,WAAW;EACX,yBAAyB;AAC3B;;AAEA,kCAAkC;AAClC;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,UAAU;EACV,aAAa;EACb,yBAAyB;AAC3B;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,mBAAmB;EACnB,SAAO;EACP,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uCAAuC;AACzC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,4BAA4B;AAC5B;;;EAGE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA,0CAA0C;AAC1C;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;EACjC,oBAAoB;AACtB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;wBACwB;AACxB;;iFAEiF;AACjF;IACI,WAAW;IACX,cAAc;IACd,cAAc;IACd,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,cAAc,UAAU,mBAAmB;IAC3C,iBAAiB;IACjB,cAAc;AAClB;;AAEA,8CAA8C;AAC9C;;IAEI,iBAAiB;IACjB,gBAAgB;AACpB","sourcesContent":[".knowledge-info-box {\r\n    display: flex;\r\n    align-items: center;\r\n    flex-direction: row;\r\n    gap: 20px;\r\n    background-color: #5616ea25;\r\n    border-radius: 10px;\r\n    padding: 15px;\r\n    padding-top: 12px;\r\n    padding-bottom: 12px;\r\n    line-height: 1.45;\r\n    border-left: 5px solid #5616ea;\r\n}\r\n\r\n.knowledge-info-text {\r\n    display: flex;\r\n    align-items: left;\r\n    flex-direction: column;\r\n}\r\n\r\n.knowledge-info-text p {\r\n    margin: 0;\r\n    padding: 0;\r\n}\r\n\r\n.knowledge-info-text ul {\r\n    margin: 0.5rem 0;\r\n    padding-left: 1.2rem;\r\n    list-style-type: disc;\r\n    margin-bottom: 0;\r\n    margin-top: 5px;\r\n}\r\n\r\n.knowledge-info-text li {\r\n    margin-top: 7px;\r\n}\r\n\r\n.knowledge-info-icon {\r\n    font-size: 24px;\r\n    color: #5616ea;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.knowledge-tab-info-box {\r\n  margin-top: 0px;\r\n}\r\n\r\n.file-tag-parent {\r\n    display: flex;\r\n    flex-direction: row;\r\n    text-align: center;\r\n    align-items: center;\r\n    flex-wrap: wrap;\r\n    gap: 8px;\r\n}\r\n\r\n.file-tag {\r\n    display: inline-block;\r\n    padding: 5px;\r\n    padding-right: 7px;\r\n    padding-top: 1px;\r\n    padding-bottom: 1px;\r\n    border-radius: 10px;\r\n    background-color: #5616ea;\r\n    color: white;\r\n}\r\n\r\n.expand-toggle {\r\n    background-color: transparent;\r\n    border: none;\r\n    outline: none;\r\n    font-size: 24px;\r\n    padding-bottom: 10px;\r\n    cursor: pointer;\r\n    transition: 0.3s ease, color 0.3s ease;\r\n    color: #5616ea;\r\n}\r\n\r\n.expand-toggle:hover {\r\n    scale: 1.15;\r\n}\r\n\r\n.rescraping-activate-settings-container {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n}\r\n\r\n.rescraping-toggle {\r\n  margin: 0 !important;\r\n}\r\n\r\n.rescraping-settings-button {\r\n    background-color: transparent;\r\n    border: none;\r\n    outline: none;\r\n    font-size: 20px;\r\n    color: rgb(79, 79, 79);\r\n    transition: 0.4s ease, color 0.3s ease;\r\n    cursor: pointer;\r\n    margin-top: 2px;\r\n}\r\n\r\n.rescraping-settings-button:hover {\r\n    scale: 1.15;\r\n}\r\n\r\n.rescraping-settings-button:disabled {\r\n    cursor: not-allowed;\r\n    scale: 1.0;\r\n}\r\n\r\n.rescraping-toggle-loading {\r\n    display: flex;\r\n    align-items: center;\r\n    font-size: 14px;\r\n    color: #333;\r\n    padding: 9px 0;\r\n    margin-left: 11px;\r\n}\r\n\r\n/* --- Usage bar styles (used in selection-container via botSettings) --- */\r\n\r\n.knowledge-tabs {\r\n  display: flex;\r\n  padding: 6px;\r\n  padding-top: 12px;\r\n  padding-bottom: 6px;\r\n  padding-left: 8px;\r\n  border-radius: 8px;\r\n  gap: 20px;\r\n  overflow-x: auto;\r\n  -webkit-overflow-scrolling: touch;\r\n  scrollbar-width: none;\r\n  -ms-overflow-style: none;\r\n  margin-top: -6px;\r\n  margin-bottom: -6px;\r\n}\r\n\r\n.knowledge-tabs::-webkit-scrollbar {\r\n  display: none;\r\n}\r\n\r\n.knowledge-tab {\r\n  all: unset;\r\n  position: relative;\r\n  cursor: pointer;\r\n  font-size: 17px;\r\n  padding: 8px 10px;\r\n  border: 2px solid transparent;\r\n  border-radius: 8px;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  color: #353b43;\r\n  transition: background 0.2s, color 0.2s, font-weight 0.2s;\r\n  box-shadow: 0 0 0 1px #e3e4e7;\r\n  flex-shrink: 0;\r\n  white-space: nowrap;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.knowledge-tab:last-child {\r\n  margin-right: 0;\r\n}\r\n\r\n.knowledge-tab:hover {\r\n  background: #e5e7eb;\r\n  transition: background 0.2s, color 0.2s, box-shadow 0.2s;\r\n}\r\n\r\n.knowledge-tab.active {\r\n  background: #ffffff;\r\n  border-color: transparent;\r\n  color: #111827;\r\n  box-shadow: none;\r\n  transition: background 0.2s, color 0.2s, box-shadow 0.2s;\r\n}\r\n\r\n.knowledge-tab.active:hover {\r\n  background: #ffffff;\r\n}\r\n\r\n.knowledge-tab-border-svg {\r\n  position: absolute;\r\n  inset: -2px;\r\n  width: calc(100% + 4px);\r\n  height: calc(100% + 4px);\r\n  overflow: visible;\r\n  pointer-events: none;\r\n  z-index: 1;\r\n}\r\n\r\n.knowledge-tab-border-rect {\r\n  x: 0.5px;\r\n  y: 0.5px;\r\n  width: calc(100% - 1px);\r\n  height: calc(100% - 1px);\r\n  rx: 8px;\r\n  ry: 8px;\r\n  fill: none;\r\n  stroke: #5616ea;\r\n  stroke-width: 1px;\r\n  stroke-dasharray: 100;\r\n  stroke-dashoffset: 100;\r\n  /* No vector-effect: see ChatHistories.css .platform-filter-border-rect. */\r\n  shape-rendering: geometricPrecision;\r\n}\r\n\r\n.knowledge-tab.active .knowledge-tab-border-rect {\r\n  animation: knowledgeTabBorderDraw 0.7s ease-out forwards;\r\n}\r\n\r\n@keyframes knowledgeTabBorderDraw {\r\n  to {\r\n    stroke-dashoffset: 0;\r\n  }\r\n}\r\n\r\n.knowledge-tab-badge {\r\n  position: absolute;\r\n  top: -13px;\r\n  right: -7px;\r\n  background-color: #5616ea;\r\n  color: #fff;\r\n  border-radius: 8px;\r\n  padding: 5px;\r\n  padding-bottom: 4px;\r\n  font-size: 10px;\r\n  font-weight: 600;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.03em;\r\n  box-shadow: 0 2px 6px rgba(94, 27, 255, 0.4);\r\n  white-space: nowrap;\r\n}\r\n\r\n.rescraping-new-badge {\r\n  background-color: #5616ea;\r\n  color: #fff;\r\n  border-radius: 8px;\r\n  padding: 5px;\r\n  padding-bottom: 4px;\r\n  font-size: 10px;\r\n  font-weight: 600;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.03em;\r\n  box-shadow: 0 2px 6px rgba(94, 27, 255, 0.4);\r\n  white-space: nowrap;\r\n}\r\n\r\n.coming-soon-badge {\r\n  background-color: #e5e7eb;\r\n  color: #6b7280;\r\n  border-radius: 6px;\r\n  padding: 4px 6px;\r\n  font-size: 10px;\r\n  font-weight: 500;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.02em;\r\n  white-space: nowrap;\r\n}\r\n\r\n/* --- FAQ form should look like a knowledge-container box --- */\r\n.faq-form {\r\n  display: flex;\r\n  flex-direction: column;\r\n  border: none;\r\n  background-color: transparent;\r\n  padding: 20px;\r\n  padding-right: 45px;\r\n  padding-top: 15px;\r\n  gap: 10px;\r\n\r\n}\r\n\r\n.faq-label {\r\n  font-size: 14px;\r\n  color: #353535;\r\n  font-weight: 600;\r\n  margin-top: 8px;\r\n  margin-bottom: 4px;\r\n}\r\n\r\n.faq-input,\r\n.faq-textarea {\r\n  width: 100%;\r\n  font-size: 14px;\r\n  padding: 8px 10px;\r\n  border-radius: 8px;\r\n  border: 1px solid #d1d5db;\r\n  background-color: #fff;\r\n  font-family: \"DM Sans\", sans-serif;\r\n}\r\n\r\n.faq-input:focus,\r\n.faq-textarea:focus {\r\n  outline: none;\r\n  border-color: #5616ea;\r\n  box-shadow: 0 0 0 3px rgba(94, 27, 255, 0.18);\r\n}\r\n\r\n.faq-add-btn {\r\n  background-color: #5616ea;\r\n  color: white;\r\n  padding: 10px 20px;\r\n  border: none;\r\n  border-radius: 8px;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: 0.3s ease;\r\n}\r\n\r\n.faq-add-btn:hover {\r\n  background-color: #4915cc;\r\n}\r\n\r\n.faq-add-btn:disabled {\r\n  opacity: 0.55;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.faq-row {\r\n  display: flex;\r\n  align-items: center;\r\n  border: 1px solid #e5e7eb;\r\n  background-color: #ffffff;\r\n  padding: 12px;\r\n  border-radius: 10px;\r\n}\r\n\r\n.faq-row + .faq-row {\r\n  margin-top: 10px;\r\n}\r\n\r\n.faq-row-question {\r\n  font-size: 14px;\r\n  color: #111827;\r\n  font-weight: 500;\r\n}\r\n\r\n.knowledge-tab-count {\r\n  position: absolute;\r\n  top: -10px;\r\n  left: -7px;\r\n  z-index: 2;\r\n  background-color: #ffffff;\r\n  color: #000000;\r\n  border-radius: 8px;\r\n  font-size: 12px;\r\n  padding: 1px 4px;\r\n  font-weight: 500;\r\n  white-space: nowrap;\r\n  border: 0.5px solid rgb(171, 171, 171);\r\n}\r\n\r\n/* --- Search input next to header title --- */\r\n.header-title-with-search {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 16px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.knowledge-search-container {\r\n  position: relative;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.knowledge-search-icon {\r\n  position: absolute;\r\n  left: 10px;\r\n  color: #9ca3af;\r\n  font-size: 14px;\r\n  pointer-events: none;\r\n}\r\n\r\n.knowledge-search-input {\r\n  padding: 6px 28px 6px 32px;\r\n  font-size: 14px;\r\n  border: 1px solid #d1d5db;\r\n  border-radius: 8px;\r\n  outline: none;\r\n  width: 180px;\r\n  transition: border-color 0.2s, box-shadow 0.2s;\r\n  font-family: \"DM Sans\", sans-serif;\r\n}\r\n\r\n.knowledge-search-input:focus {\r\n  border-color: #5616ea;\r\n  box-shadow: 0 0 0 3px rgba(86, 22, 234, 0.15);\r\n}\r\n\r\n.knowledge-search-input::placeholder {\r\n  color: #9ca3af;\r\n}\r\n\r\n.knowledge-search-clear {\r\n  position: absolute;\r\n  right: 8px;\r\n  background: none;\r\n  border: none;\r\n  padding: 0;\r\n  cursor: pointer;\r\n  color: #9ca3af;\r\n  font-size: 14px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: color 0.2s;\r\n}\r\n\r\n.knowledge-search-clear:hover {\r\n  color: #6b7280;\r\n}\r\n\r\n/* --- Tree View Styles --- */\r\n.knowledge-tree-content {\r\n  padding-bottom: 10px;\r\n}\r\n\r\n/* Disable ALL visual feedback in tree view on row interaction */\r\n.knowledge-tree-content .MuiTreeItem-content,\r\n.knowledge-tree-content .MuiTreeItem-content:hover,\r\n.knowledge-tree-content .MuiTreeItem-content:focus,\r\n.knowledge-tree-content .MuiTreeItem-content:active,\r\n.knowledge-tree-content .MuiTreeItem-content.Mui-focused,\r\n.knowledge-tree-content .MuiTreeItem-content.Mui-selected {\r\n  background-color: transparent !important;\r\n}\r\n\r\n/* Disable all transitions on tree content */\r\n.knowledge-tree-content .MuiTreeItem-content * {\r\n  transition: none !important;\r\n}\r\n\r\n/* Checkbox specific overrides */\r\n.knowledge-tree-content .MuiCheckbox-root:hover,\r\n.knowledge-tree-content .MuiCheckbox-root:focus,\r\n.knowledge-tree-content .MuiCheckbox-root:active,\r\n.knowledge-tree-content .MuiCheckbox-root.Mui-focusVisible {\r\n  background-color: transparent !important;\r\n}\r\n\r\n.knowledge-tree-content .MuiCheckbox-root .MuiTouchRipple-root {\r\n  display: none;\r\n}\r\n\r\n/* Lock checkbox icon color - purple border when unchecked */\r\n.knowledge-tree-content .MuiCheckbox-root svg,\r\n.knowledge-tree-select-all-row .MuiCheckbox-root svg {\r\n  color: #5616ea !important;\r\n}\r\n\r\n.knowledge-tree-content .MuiCheckbox-root.Mui-checked svg,\r\n.knowledge-tree-select-all-row .MuiCheckbox-root.Mui-checked svg {\r\n  color: #5616ea !important;\r\n}\r\n\r\n/* Lock date/calendar icon color */\r\n.knowledge-tree-content .knowledge-tree-item-date,\r\n.knowledge-tree-content .knowledge-tree-item-date svg,\r\n.knowledge-tree-content .MuiTreeItem-content:focus .knowledge-tree-item-date,\r\n.knowledge-tree-content .MuiTreeItem-content:active .knowledge-tree-item-date,\r\n.knowledge-tree-content .MuiTreeItem-content.Mui-focused .knowledge-tree-item-date,\r\n.knowledge-tree-content .MuiTreeItem-content.Mui-selected .knowledge-tree-item-date,\r\n.knowledge-tree-content .MuiTreeItem-content:focus .knowledge-tree-item-date svg,\r\n.knowledge-tree-content .MuiTreeItem-content:active .knowledge-tree-item-date svg,\r\n.knowledge-tree-content .MuiTreeItem-content.Mui-focused .knowledge-tree-item-date svg,\r\n.knowledge-tree-content .MuiTreeItem-content.Mui-selected .knowledge-tree-item-date svg {\r\n  color: #9ca3af !important;\r\n}\r\n\r\n/* Lock action button colors */\r\n.knowledge-tree-content .knowledge-action-button,\r\n.knowledge-tree-content .knowledge-action-button svg,\r\n.knowledge-tree-content .MuiTreeItem-content:focus .knowledge-action-button,\r\n.knowledge-tree-content .MuiTreeItem-content:active .knowledge-action-button,\r\n.knowledge-tree-content .MuiTreeItem-content.Mui-focused .knowledge-action-button,\r\n.knowledge-tree-content .MuiTreeItem-content.Mui-selected .knowledge-action-button,\r\n.knowledge-tree-content .MuiTreeItem-content:focus .knowledge-action-button svg,\r\n.knowledge-tree-content .MuiTreeItem-content:active .knowledge-action-button svg,\r\n.knowledge-tree-content .MuiTreeItem-content.Mui-focused .knowledge-action-button svg,\r\n.knowledge-tree-content .MuiTreeItem-content.Mui-selected .knowledge-action-button svg {\r\n  color: #464646 !important;\r\n}\r\n\r\n/* Lock text colors */\r\n.knowledge-tree-content .knowledge-tree-item-path,\r\n.knowledge-tree-content .MuiTreeItem-content:focus .knowledge-tree-item-path,\r\n.knowledge-tree-content .MuiTreeItem-content:active .knowledge-tree-item-path,\r\n.knowledge-tree-content .MuiTreeItem-content.Mui-focused .knowledge-tree-item-path,\r\n.knowledge-tree-content .MuiTreeItem-content.Mui-selected .knowledge-tree-item-path {\r\n  color: #4b5563 !important;\r\n}\r\n\r\n.knowledge-tree-content .knowledge-tree-domain-name,\r\n.knowledge-tree-content .MuiTreeItem-content:focus .knowledge-tree-domain-name,\r\n.knowledge-tree-content .MuiTreeItem-content:active .knowledge-tree-domain-name,\r\n.knowledge-tree-content .MuiTreeItem-content.Mui-focused .knowledge-tree-domain-name,\r\n.knowledge-tree-content .MuiTreeItem-content.Mui-selected .knowledge-tree-domain-name {\r\n  color: #111827 !important;\r\n}\r\n\r\n.knowledge-tree-content .knowledge-tree-path-name,\r\n.knowledge-tree-content .MuiTreeItem-content:focus .knowledge-tree-path-name,\r\n.knowledge-tree-content .MuiTreeItem-content:active .knowledge-tree-path-name,\r\n.knowledge-tree-content .MuiTreeItem-content.Mui-focused .knowledge-tree-path-name,\r\n.knowledge-tree-content .MuiTreeItem-content.Mui-selected .knowledge-tree-path-name {\r\n  color: #374151 !important;\r\n}\r\n\r\n/* Lock count badge colors */\r\n.knowledge-tree-content .knowledge-tree-count,\r\n.knowledge-tree-content .MuiTreeItem-content:focus .knowledge-tree-count,\r\n.knowledge-tree-content .MuiTreeItem-content:active .knowledge-tree-count,\r\n.knowledge-tree-content .MuiTreeItem-content.Mui-focused .knowledge-tree-count,\r\n.knowledge-tree-content .MuiTreeItem-content.Mui-selected .knowledge-tree-count {\r\n  color: #464646 !important;\r\n  background-color: #f3f4f6 !important;\r\n}\r\n\r\n/* Lock folder icon colors */\r\n.knowledge-tree-content .knowledge-tree-domain-label svg,\r\n.knowledge-tree-content .knowledge-tree-path-label svg,\r\n.knowledge-tree-content .MuiTreeItem-content:focus .knowledge-tree-domain-label svg,\r\n.knowledge-tree-content .MuiTreeItem-content:active .knowledge-tree-domain-label svg,\r\n.knowledge-tree-content .MuiTreeItem-content.Mui-focused .knowledge-tree-domain-label svg,\r\n.knowledge-tree-content .MuiTreeItem-content.Mui-selected .knowledge-tree-domain-label svg,\r\n.knowledge-tree-content .MuiTreeItem-content:focus .knowledge-tree-path-label svg,\r\n.knowledge-tree-content .MuiTreeItem-content:active .knowledge-tree-path-label svg,\r\n.knowledge-tree-content .MuiTreeItem-content.Mui-focused .knowledge-tree-path-label svg,\r\n.knowledge-tree-content .MuiTreeItem-content.Mui-selected .knowledge-tree-path-label svg {\r\n  color: #5616ea !important;\r\n}\r\n\r\n/* Loading spinner icon color */\r\n.knowledge-loading-spinner-icon {\r\n  color: #5616ea !important;\r\n}\r\n\r\n.knowledge-tree-select-all-row {\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 4px 0;\r\n  margin-bottom: 0;\r\n  flex-wrap: wrap;\r\n  gap: 12px;\r\n}\r\n\r\n/* Scraping links indicator */\r\n.scraping-links-indicator {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  background-color: #fef3c7;\r\n  border: 1px solid #fbbf24;\r\n  border-radius: 8px;\r\n  padding: 6px 12px;\r\n  font-size: 13px;\r\n}\r\n\r\n.scraping-indicator-icon {\r\n  color: #f59e0b;\r\n  font-size: 14px;\r\n}\r\n\r\n.scraping-indicator-text {\r\n  color: #92400e;\r\n  font-weight: 500;\r\n}\r\n\r\n.knowledge-tree-select-all-label {\r\n  flex: 1;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  color: #111827;\r\n  margin-left: 8px;\r\n}\r\n\r\n.knowledge-tree-domain-label {\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 6px 0;\r\n  font-weight: 500;\r\n}\r\n\r\n.knowledge-tree-domain-name {\r\n  flex: 1;\r\n  font-size: 14px;\r\n  color: #111827;\r\n}\r\n\r\n.knowledge-tree-domain-count {\r\n  background-color: #e5e7eb;\r\n  color: #374151;\r\n  border-radius: 10px;\r\n  padding: 2px 8px;\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n  margin-left: 8px;\r\n}\r\n\r\n/* Unified icon box sizing for tree items */\r\n.knowledge-icon-box {\r\n  min-width: 36px;\r\n  height: 28px;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  box-sizing: border-box;\r\n  border-radius: 6px;\r\n  font-size: 11px;\r\n  padding: 0 6px;\r\n}\r\n\r\n/* Count badge for tree items */\r\n.knowledge-tree-count {\r\n  background-color: #f3f4f6;\r\n  color: #464646;\r\n  font-weight: 500;\r\n}\r\n\r\n/* Path segment level (folder) */\r\n.knowledge-tree-path-label {\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 5px 0;\r\n  font-weight: 500;\r\n}\r\n\r\n.knowledge-tree-path-name {\r\n  flex: 1;\r\n  font-size: 13px;\r\n  color: #374151;\r\n}\r\n\r\n.knowledge-tree-path-count {\r\n  background-color: #fef3c7;\r\n  color: #92400e;\r\n  border-radius: 10px;\r\n  padding: 2px 8px;\r\n  font-size: 11px;\r\n  font-weight: 500;\r\n  margin-left: 8px;\r\n}\r\n\r\n.knowledge-tree-item-label {\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 4px 0;\r\n  width: 100%;\r\n}\r\n\r\n.knowledge-tree-item-path {\r\n  flex: 1;\r\n  font-size: 13px;\r\n  color: #4b5563;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  max-width: 300px;\r\n}\r\n\r\n.knowledge-tree-item-actions {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  margin-left: auto;\r\n  padding-left: 16px;\r\n}\r\n\r\n.knowledge-tree-item-date {\r\n  font-size: 12px;\r\n  color: #9ca3af;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.knowledge-bulk-actions {\r\n  font-size: 15px;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n    .file-tag-parent {\r\n        gap: 5px;\r\n    }\r\n\r\n    .knowledge-header {\r\n        flex-wrap: wrap;\r\n        gap: 10px;\r\n    }\r\n\r\n    .knowledge-header .header-title-with-search {\r\n        flex-basis: 100%;\r\n        order: 2;\r\n        flex-direction: column;\r\n        align-items: flex-start;\r\n        gap: 0;\r\n    }\r\n\r\n    .knowledge-header .header-title-with-search .header-title {\r\n        width: auto;\r\n        margin-bottom: 10px;\r\n    }\r\n\r\n    .knowledge-header .knowledge-bulk-actions {\r\n        order: 1;\r\n        flex-basis: 100%;\r\n        justify-content: flex-start !important;\r\n    }\r\n\r\n    .knowledge-header .knowledge-search-container {\r\n        width: 100%;\r\n    }\r\n\r\n    .knowledge-search-input {\r\n        width: 100%;\r\n        max-width: none;\r\n    }\r\n}\r\n\r\n/* --- Virtualized Tree Styles --- */\r\n.virtual-tree-row {\r\n  display: flex;\r\n  align-items: center;\r\n  overflow: hidden;\r\n}\r\n\r\n.virtual-tree-expand-btn {\r\n  width: 20px;\r\n  height: 20px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  padding: 0;\r\n  margin-right: 4px;\r\n  color: #6b7280;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.virtual-tree-expand-btn:hover {\r\n  color: #374151;\r\n}\r\n\r\n.virtual-tree-expand-btn svg {\r\n  font-size: 12px;\r\n}\r\n\r\n.virtual-tree-expand-placeholder {\r\n  width: 20px;\r\n  margin-right: 4px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n/* Tree line indicator for leaf nodes (links without children) */\r\n.virtual-tree-line-indicator {\r\n  width: 20px;\r\n  height: 20px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  margin-right: 4px;\r\n  margin-top: 2px;\r\n  flex-shrink: 0;\r\n  position: relative;\r\n}\r\n\r\n/* Vertical line (going up) */\r\n.virtual-tree-line-indicator::before {\r\n  content: '';\r\n  position: absolute;\r\n  left: 10%;\r\n  top: 30%;\r\n  width: 2px;\r\n  height: 20%;\r\n  background-color: #5616ea;\r\n}\r\n\r\n/* Horizontal line (going right) */\r\n.virtual-tree-line-indicator::after {\r\n  content: '';\r\n  position: absolute;\r\n  left: 10%;\r\n  top: 50%;\r\n  width: 70%;\r\n  height: 1.5px;\r\n  background-color: #5616ea;\r\n}\r\n\r\n/* Clickable row area for expand/collapse */\r\n.virtual-tree-row-clickable {\r\n  display: flex;\r\n  align-items: center;\r\n  flex: 1;\r\n  cursor: pointer;\r\n  border-radius: 4px;\r\n  padding: 2px 4px;\r\n  margin: -2px -4px;\r\n  transition: background-color 0.15s ease;\r\n}\r\n\r\n.virtual-tree-row-clickable:hover {\r\n  background-color: rgba(86, 22, 234, 0.06);\r\n}\r\n\r\n/* Virtualized tree labels */\r\n.virtual-tree-row .knowledge-tree-domain-label,\r\n.virtual-tree-row .knowledge-tree-path-label,\r\n.virtual-tree-row .knowledge-tree-item-label {\r\n  display: flex;\r\n  align-items: center;\r\n  width: 100%;\r\n  height: 100%;\r\n  box-sizing: border-box;\r\n}\r\n\r\n/* Checkbox styling for virtualized tree */\r\n.virtual-tree-row .MuiCheckbox-root svg {\r\n  color: #5616ea !important;\r\n}\r\n\r\n.virtual-tree-row .MuiCheckbox-root.Mui-checked svg {\r\n  color: #5616ea !important;\r\n}\r\n\r\n/* Show more button styles */\r\n.knowledge-tree-show-more {\r\n  display: flex;\r\n  align-items: center;\r\n  width: 100%;\r\n  height: 100%;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.knowledge-tree-show-more-btn {\r\n  background: none;\r\n  border: none;\r\n  color: #5616ea;\r\n  font-size: 13px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  padding: 4px 8px;\r\n  border-radius: 6px;\r\n  transition: background-color 0.2s;\r\n  font-family: inherit;\r\n}\r\n\r\n.knowledge-tree-show-more-btn:hover {\r\n  background-color: rgba(86, 22, 234, 0.1);\r\n}\r\n\r\n/* Why a row failed (knowledgeStatus.js): short inline note next to the red X,\r\n   full text on hover. */\r\n/* Failed-row reason (knowledgeStatus.js). On the card lists it is its own flex\r\n   cell between the name and the date: the name column gives up its fixed 60%\r\n   width on such rows so the reason gets the whole middle and rarely truncates. */\r\n.knowledge-item:has(> .knowledge-failure-slot) > .knowledge-link {\r\n    width: auto;\r\n    flex: 0 0 auto;\r\n    max-width: 45%;\r\n    min-width: 0;\r\n    white-space: nowrap;\r\n}\r\n\r\n.knowledge-item:has(> .knowledge-failure-slot) > .knowledge-link .knowledge-status-link {\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n}\r\n\r\n.knowledge-failure-slot {\r\n    flex: 1 1 auto;\r\n    min-width: 0;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    padding: 0 16px;\r\n}\r\n\r\n.knowledge-failure-slot .info-tooltip-wrapper {\r\n    min-width: 0;\r\n    max-width: 100%;\r\n}\r\n\r\n.knowledge-failure-reason {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    gap: 6px;\r\n    max-width: 100%;\r\n    min-width: 0;\r\n    font-size: 0.8rem;\r\n    font-weight: 400;\r\n    color: #b42318;\r\n    vertical-align: middle;\r\n    cursor: default;\r\n}\r\n\r\n.knowledge-failure-text {\r\n    min-width: 0;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n}\r\n\r\n.knowledge-failure-icon {\r\n    color: #f79009;         /* warning orange */\r\n    font-size: 0.9rem;\r\n    flex-shrink: 0;\r\n}\r\n\r\n/* Inline variant (website-links tree rows). */\r\n.virtual-tree-row .knowledge-failure-reason,\r\n.knowledge-tree-item .knowledge-failure-reason {\r\n    margin-left: 10px;\r\n    max-width: 380px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
